export const Enums = {
    DATE: {
        YEAR_FIRST_DAY: "first-day-year",
        YEAR_END_DAY: "end-day-year",
        MONTH_FIRST_DAY: "first-day-month",
        MONTH_END_DAY: "end-day-month",
        YEAR: "year",
        MONTH: "month",
        DAY: "day",
        HOUR: "hour",
        MINUTE: "minute",
        SECOND: "second",
    },
    DAYOFWEEK: {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    },
    LESSON: {
        TURKISH: "turkish",
        MATH: "math",
        SOCIAL: "social-studies",
        SCIENCE: "science",
    },
    LESSON_ICON: {
        TURKISH: "icon-turkish-lesson",
        MATH: "icon-maths-lesson",
        SOCIAL: "icon-social-science-lesson",
        SCIENCE: "icon-chemistry-lesson",
    },
    STATUS: {
        INFO: 0,
        ERROR: 1,
        SUCCESS: 2,
        WARNING: 3,
    },
    HTTPSTATUS: {
        BadRequest: 400,
        Unauthorized: 401,
        Forbidden: 403,
        NotFound: 404,
        RequestTimeout: 408,
        TooManyRequests: 429
    },
    THEME: {
        NULL: 0,
        EMPTY: 1, // Login, 404, 500, Default
        CLASSIC: 2,
    },
    SERVICE: {
        SETTING: "Setting",
        USER: "User",
        CITY: "City",
        DISTRICT: "District",
        CONTRACT: "Contract",
        USER_CONTRACT: "UserContract",
        CONTACT: "Contact",
        ANNOUNCEMENT: "Announcement",
        APPOINTMENT: "Appointment",

        MEETING: "Meeting",
        MEETING_FILE: "MeetingFile",
        MEETING_RECORDING: "MeetingRecording",
        

        STUDENT_TEACHER: "StudentTeacher",

        STUDENT_LESSON_TEACHER: "StudentLessonTeacher",
        STUDENT_HOW_TO_STUDY: "StudentHowToStudy",
        STUDENT_WEEKLY_PLAN: "StudentWeeklyPlan",
        STUDENT_PLAN: "StudentPlan",
        STUDENT_REPEATER: "StudentRepeater",
        STUDENT_ROUTINE: "StudentRoutine",

        NOTIFICATION: "UserNotification",
        MESSAGE: "Message",
        USER_PAYMENT_CARD: "UserPaymentCard",
        USER_PACKAGE: "UserPackage",

        CLASS_ROOM: "ClassRoom",
        LESSON_AREA: "LessonArea",
        LESSON_GROUP: "LessonGroup",
        LESSON: "Lesson",
        LESSON_SUBJECT: "LessonSubject",
        LESSON_TEACHER: "LessonTeacher",
        LESSON_TEACHER_RELATION: "LessonTeacherRelation",
        LESSON_KBS: "LessonKBS",
        HOW_TO_STUDY: "HowToStudy",
        INITIAL_ANALYSIS: "InitialAnalysis",
        PACKAGE: "Package",
        PAST_YEAR_QUESTION: "PastYearQuestion",
        PAYMENT: "Payment",
        QUESTION_POOL: "QuestionPool",
        RESOURCE_BOOK: "ResourceBook",
        TEST_POOL: "TestPool",

        PRIVATE_QUESTION_POOL: "PrivateQuestionPool",
        PRIVATE_TEST_POOL: "PrivateTestPool",

        STUDENT_RESOURCE_BOOK: "StudentResourceBook",
        STUDENT_TRIAL_EXAM: "StudentTrialExam",
        STUDENT_TEST_POOL: "StudentTestPool",

        TEACHER_RESOURCE_BOOK: "TeacherResourceBook",
        TEACHER_AVAILABILITY: "TeacherAvailability",

        GLOBAL_FILE: "GlobalFile",
        GLOBAL_FILE_CATEGORY: "GlobalFileCategory",
        SHARED_FILE: "SharedFile",

        PROGRESS_PAYMENT: "ProgressPayment",
        INSTRUCTOR: "Instructor", 
        INSTRUCTOR_COMMENT: "InstructorComment", 

        CHANNEL_PLAYBACK: "ChannelPlayback",
        YOUTUBE: "youtube",
    },
    USER_TYPE: {
        NULL: 0,
        STUDENT: 1,
        CANDIDATE: 2,
        TEACHER: 3,
        INSTRUCTOR: 4,
    },
    SETTING: {
        GENEL: 1,
        ILETISIM: 2,
        SOSYAL_MEDYA: 3,
        EPOSTA: 4,
        SMS: 5,
    },
    LOGIN_TYPE: {
        GOOGLE: 1,
        FACEBOOK: 2,
        TWITTER: 3,
        APPLE: 4
    },
    MENU_TYPE: {
        MAIN: 0,
        PLAN: 2,
        RESOURCE: 3,
        DOCUMENT: 4,

        SUB_MAIN: 5,
        SUB_PLAN: 6,
        SUB_RESOURCE: 7,
        SUB_DOCUMENT: 8,

        LIVE_EDUCATION: 9
    },
    PACKAGE_GROUP: {
        TRAINING: 1,
        YKS: 2,
        LGS: 3,
        KPSS: 4,
    },
    PAYMENT_TYPE: {
        CREDIT_CARD: 1,
        MONEY_TRANSFER: 2,
    },
    PACKAGE_TYPE: {
        INSTRUCTOR_TRAININGS: 1,
        YKS: 2,
        LGS: 3,
        YKS_PREFERENCE: 4,
        LGS_PREFERENCE: 5,
        LIVE_EDUCATION: 6,
        KPSS: 7,
    },
    PACKAGE_STATE: {
        PENDING: 1,
        ATCHECKOUT: 2,
        PAID: 3,
        ERROR: 4,
        CANCELED: 5,
        RETURNED: 6,
        MEMBER_CANCELED: 7,
    },
    QUESTION_TYPE: {
        NONE: 0,
        GENERAL: 1,
        PARAGRAPH: 2,
        CALCULATION: 3,
        CHECKUP: 4,
        SCANNING: 5,
        CAUTION: 6,
        MICRO: 7,
        MACRO: 8,
    },
    RESOURCEBOOK_TYPE: {
        LECTURE: 1,
        QUESTION_BANK: 2,
        TRIAL: 3,
    },
    RESOURCEBOOK_DIFFICULTY: {
        EASY: 1,
        MEDIUM: 2,
        HARD: 3,
    },
    QUIZ_TEMPLATE: {
        WRITTEN_PAPER_TEST: 1,
        LEAF_TEST: 2,
        TRIAL_EXAM_TEST: 3,
    },
    TEST_TYPE: {
        CHECKUP: 1,
        SCANNING: 2,
    },
    TEST_DIFFICULTY: {
        EASY: 1,
        MEDIUM: 2,
        HARD: 3,
    },
    DOCUMENT_TYPE: {
        PDF: 1,
        VIDEO: 2,
    },
    NOTIFICATION_TYPE: {
        WELCOME: 1,
        NEW_DEMAND_ARRIVED: 2,
    },
    RIGHT_TYPE: {
        DASHBOARD: 1,
        WEEKLY: 2,
        DAILY: 3,
        LESSON: 4,
        ANALYSIS: 5,
        TEST: 6,
    },
    RIGHT_SELECTED: {
        LESSON_TEACHER: 1,
        HOW_STUDY: 2,
        RESOURCE: 3,
        WEEKLY_PLAN_PREVIEW: 4,
        DAILY_WORK_TIME: 5,
        MEETING_MOOD: 6,
        WEEKLY_WORK_TIME: 7,
    },
    TRIAL_TYPE: {
        GENERAL: 1,
        AREA: 2,
        BRANCH: 3,
    },
    TRIAL_WRONG_TYPE: {
        READING_PROCESS_ERROR: 1,
        LACK_TOPIC: 2,
        LACK_TIME: 3,
        //MISREADING : 1,
        //PROCESS_ERROR: 2,
        //CONCEPT_MIXING: 3,
        //SOLVING_OVER: 4,
        //LACK_TOPIC: 5,
        //LACK_TIME: 6,
        //PROCESS_NOT: 7,
    },
    TRIAL_EMPTY_TYPE: {
        READING_PROCESS_ERROR: 1,
        LACK_TOPIC: 2,
        LACK_TIME: 3,
        //MISREADING : 1,
        //PROCESS_ERROR: 2,
        //CONCEPT_MIXING: 3,
        //SOLVING_OVER: 4,
        //LACK_TOPIC: 5,
        //LACK_TIME: 6,
        //PROCESS_NOT: 7,
    },
    MEETING_SERVER: {
        NONE: 0,
        GOOGLE_MEET: 1,
        ZOOM: 2,
        AGORA: 3,
    },
    MEETING_STATE: {
        NONE: 0,
        PENDING: 1,
        DONE: 2,
        POSTPONED: 3,
        TEACHER_NOT_AVAILABLE: 4,
        STUDENT_NOT_AVAILABLE: 5,
        ERROR: 6,
    },
    QUESTION_TYPE: {
        NONE: 0,
        GENERAL: 1,
        PARAGRAPH: 2,
        CALCULATION: 3,
        CHECKUP: 4,
        SCANNING: 5,
        CAUTION: 6,
        MICRO: 7,
        MACRO: 8,
    },
    VIDEO_SERVICE: {
        YOUTUBE: 1,
        VIMEO: 2,
    },
    ROUTINE_TYPE: {
        P_MERDIVEN: 1,
        COZ_ANALIZ: 2,
        PARAGRAF_COZME: 3,
        KAVRAMSALLASTIRMA: 4,
        OKU_ANLAT : 5,
        OZETLEME: 6,
        GOREV: 7,
    },
    FILE_TYPE: [
        {
            Group: "image",
            Extension: ".jpg",
            MimeType: ["image/jpeg", "image/jpg"],
        },
        {
            Group: "image",
            Extension: ".png",
            MimeType: ["image/png"],
        },
        {
            Group: "image",
            Extension: ".webp",
            MimeType: ["image/webp"],
        },
        {
            Group: "image",
            Extension: ".avif",
            MimeType: ["image/avif"],
        },
        {
            Group: "image",
            Extension: ".gif",
            MimeType: ["image/gif"],
        },
        {
            Group: "image",
            Extension: ".svg",
            MimeType: ["image/svg+xml"],
        },
        {
            Group: "video",
            Extension: ".mp4",
            MimeType: ["video/mp4", "application/mp4"],
        },
        {
            Group: "video",
            Extension: ".mpeg",
            MimeType: ["video/mpeg"],
        },
        {
            Group: "video",
            Extension: ".avi",
            MimeType: ["video/x-msvideo"],
        },
        {
            Group: "video",
            Extension: ".flv",
            MimeType: ["video/x-flv"],
        },
        {
            Group: "video",
            Extension: ".webm",
            MimeType: ["video/webm"],
        },
        {
            Group: "audio",
            Extension: ".mp3",
            MimeType: ["audio/mpeg3", "audio/x-mpeg-3", "audio/mp3"],
        },
        {
            Group: "audio",
            Extension: ".wav",
            MimeType: ["audio/x-wav"],
        },
        {
            Group: "audio",
            Extension: ".wma",
            MimeType: ["audio/x-ms-wma"],
        },
        {
            Group: "document",
            Extension: ".doc",
            MimeType: ["application/msword"],
        },
        {
            Group: "document",
            Extension: ".docx",
            MimeType: [
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ],
        },
        {
            Group: "document",
            Extension: ".xls",
            MimeType: ["application/vnd.ms-excel"],
        },
        {
            Group: "document",
            Extension: ".xlsx",
            MimeType: [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ],
        },
        {
            Group: "document",
            Extension: ".xml",
            MimeType: ["application/xml"],
        },
        {
            Group: "document",
            Extension: ".pdf",
            MimeType: ["application/pdf"],
        },
        {
            Group: "document",
            Extension: ".csv",
            MimeType: ["text/csv"],
        },
        {
            Group: "document",
            Extension: ".txt",
            MimeType: ["text/plain"],
        },
        {
            Group: "document",
            Extension: ".htm",
            MimeType: ["text/htm"],
        },
        {
            Group: "document",
            Extension: ".html",
            MimeType: ["text/html"],
        },
    ],
};